import { render, staticRenderFns } from "./rankRule.vue?vue&type=template&id=626f5248&scoped=true&"
import script from "./rankRule.vue?vue&type=script&lang=js&"
export * from "./rankRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f5248",
  null
  
)

export default component.exports